import React from 'react';
import { useSelector } from 'react-redux';

import { getUserType } from 'redux/slices/userSlice';
import Clue from 'shared/ui/Clue';

import { ICL, TaskKeysType, UnderlineTask } from '../../../shared/types';
import StudentTaskWrapper from '../StudentTaskWrapper';

interface StudentUnderlineTaskProps extends UnderlineTask {
  icl: ICL | null;
  handleChangeTaskByKey: (id: string, key: TaskKeysType, value: any) => void;
  saveTaskAnswer: (id: string) => Promise<void>;
  hw?: boolean;
  preview?: boolean;
  studentName?: string;
  index: number;
}

export default function StudentUnderlineTask({
  icl,
  text,
  subText,
  answer,
  hasAnswer,
  hasStar,
  checkedAt,
  completedAt,
  handleChangeTaskByKey,
  id,
  hasPhoto,
  answersPhotos,
  saveTaskAnswer,
  deadline,
  audioUrl,
  videoUrl,
  taskPhotos,
  editedAnswerPhotos,
  hw,
  pdfUrl,
  wordUrl,
  studentPdfUrl,
  studentWordUrl,
  preview,
  words,
  studentName,
  index,
}: StudentUnderlineTaskProps) {
  const userType = useSelector(getUserType);

  const changeFormikWord = (wordId: string) => {
    const changedWords = words.map(word => (word.id === wordId ? { ...word, isUnderlined: !word.isUnderlined } : word));

    handleChangeTaskByKey(id, 'words', changedWords);
  };

  const areStudentAnswers = words.some(word => word.isUnderlined);
  const isDisabledSubmitButton = !areStudentAnswers || !!checkedAt || !!completedAt;

  const isStudent = userType === 'Student';
  const isButtonDisabled = !!checkedAt || !!completedAt || !isStudent || !!preview;

  return (
    <StudentTaskWrapper
      icl={icl}
      taskText={text}
      answersPhotos={answersPhotos}
      id={id}
      handleChangeTaskByKey={handleChangeTaskByKey}
      checkedAt={checkedAt}
      hasPhoto={hasPhoto}
      completedAt={completedAt}
      saveTaskAnswer={saveTaskAnswer}
      deadline={deadline}
      audioUrl={audioUrl}
      answer={answer}
      hasAnswer={hasAnswer}
      hasStar={hasStar}
      videoUrl={videoUrl}
      taskPhotos={taskPhotos}
      editedAnswerPhotos={editedAnswerPhotos}
      hw={hw}
      pdfUrl={pdfUrl}
      wordUrl={wordUrl}
      studentPdfUrl={studentPdfUrl}
      studentWordUrl={studentWordUrl}
      preview={preview}
      subText={subText}
      isDisabledSubmitButton={isDisabledSubmitButton}
      studentName={studentName}
      isSubmitButton
      index={index}
    >
      <div className="!py-5 md:!py-8">
        <Clue text="studentUnderlineHint" className="!mb-5 md:!mb-6" />

        <ul className="flex flex-wrap gap-5">
          {words.map(word => (
            <li key={word.id}>
              <button
                onClick={() => changeFormikWord(word.id)}
                disabled={isButtonDisabled}
                className={word.isUnderlined ? 'border-b border-black' : 'border-b border-transparent'}
              >
                {word.word}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </StudentTaskWrapper>
  );
}
